import React, { useRef, useState } from "react";

import { Button, Form } from "semantic-ui-react";

import HeaderCustom from "./HeaderCustom";
import InformationFormBasic, { InformationDataType } from "./InformationFormBasic";
import InformationFormDetailed, { InformationDetailedDataType } from "./InformationFormDetailed";

export type RegisterInformationProps = {
  data: InformationDataType & InformationDetailedDataType;
  layout?: "basic" | "detailed";
  healthFacilityTypeOptions: Record<string, any>[];
  onCancel: () => void;
  onSave: (data: any) => void;
};

const RegisterInformation: React.FC<RegisterInformationProps> = (props) => {
  const [error, setError] = useState<Record<string, any>>({});

  const formRef = useRef<any>(null);

  const handleSave = () => {
    const data = formRef.current.getData();

    const fieldChecks: string[] = ["accountName"];

    if (props.layout === "detailed") {
      fieldChecks.push("hospital_name");
    }

    const missingFields = fieldChecks.filter((field) => !data[field]).map((field) => field);

    if (missingFields.length > 0) {
      setError(Object.fromEntries(missingFields.map((field) => [field, true])));

      return;
    }

    props.onSave(data);
    setError({});
  };

  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <>
      <div>
        <Form>
          {props.layout === "detailed" ? (
            <InformationFormDetailed
              ref={formRef}
              detail={props.data}
              error={error}
              healthFacilityTypeOptions={props.healthFacilityTypeOptions}
            />
          ) : (
            <>
              <HeaderCustom label="สร้าง Official Account" />
              <HeaderCustom label="ข้อมูลการเข้าสู่ระบบ" />

              <InformationFormBasic
                ref={formRef}
                detail={props.data}
                error={error}
                showAccountNameLabel
              />
            </>
          )}
        </Form>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
        {props.layout !== "detailed" && (
          <Button className="primary back" onClick={handleCancel}>
            ยกเลิก
          </Button>
        )}
        <Button className="primary" onClick={handleSave}>
          ยืนยัน
        </Button>
      </div>
    </>
  );
};

export default RegisterInformation;
